"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var addSortFilters = function addSortFilters(filters, translations) {
  var _global$__appConfig__;
  var addWithoutValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var forSearchPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var sortFound = filters === null || filters === void 0 ? void 0 : filters.find(function (filter) {
    return filter.id === "sort";
  });
  var options = [{
    id: "position-desc",
    value: "position-desc",
    label: translations.recommended
  }, {
    id: "final_price-desc",
    value: "final_price-desc",
    label: translations.finalPriceLow
  }, {
    id: "final_price-asc",
    value: "final_price-asc",
    label: translations.finalPriceHigh
  }, {
    id: "name-desc",
    value: "name-desc",
    label: translations.sortByNameDesc
  }, {
    id: "name-asc",
    value: "name-asc",
    label: translations.sortByNameAsc
  }];
  if ((_global$__appConfig__ = global.__appConfig__.showSortByCatalogPrice) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : true) {
    options.push({
      id: "price-desc",
      value: "price-desc",
      label: translations.priceCatalogLow
    });
    options.push({
      id: "price-asc",
      value: "price-asc",
      label: translations.priceCatalogHigh
    });
  }
  var sort = {
    id: "sort",
    label: "Sort",
    type: "select",
    options: options,
    value: sortFound ? sortFound.value : null
  };
  if (forSearchPage) {
    sort.options.splice(0, 1);
  }
  if (sortFound && !addWithoutValue) {
    filters[filters.length - 1] = sort;
  } else {
    filters === null || filters === void 0 ? void 0 : filters.push(sort);
  }
  return filters;
};
var _default = addSortFilters;
exports["default"] = _default;